import React, { useEffect, useState } from 'react';

import '@/assets/scss/common.scss';
import '@/assets/reset.css';
import { getAbType } from '@/api/abTest.ts';
import { useTheme } from '@/hooks/useStore.ts';

const SearchNodata: React.FC = () => {
  const theme = useTheme();
  const [abType, setAbType] = useState<'A' | 'B' | undefined>(undefined);

  useEffect(() => {
    (async () => {
      const abType = await getAbType();
      setAbType(abType);
    })();
  }, []);

  return (
    <div className={`ixi-O-container ${theme}`}>
      <div className="ixi-O-contents-view">
        {/* 상단 빈 배경 */}
        <div className="ixi-O-contents-view__bg-empty"></div>

        {/* 상단 헤더 (비어있는 상태) */}
        <div className="ixi-O-contents-view__header"></div>

        {/* 메인 컨텐츠 */}
        <div className="ixi-O-contents-view__contents pt16">
          <div className="title-wrap">
            <p className="title">
              다음 통화부터 AI가
              <br />
              대화를 분석해 드려요
            </p>
            <p className="desc">
              장소 관련 정보를 쇼츠로 검색해서 제공해줘요.
              <br />
              분석된 내용은 최대 10개까지 기록됩니다.
            </p>
          </div>
          <div className="img-wrap">
            {abType === 'A' && (
              <img
                src="./res/img/discover_tutorial_1_ver_15fps.gif"
                alt="Tutorial A"
              />
            )}
            {abType === 'B' && (
              <img
                src="./res/img/discover_tutorial_B_ver2_3.gif"
                alt="Tutorial B"
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SearchNodata;
